module.exports = __webpack_public_path__ + "img/commas.363cadf9.svg";